import Handler from './handler';
import type { GetGoodsListConditionMatch, GoodsItem } from '../types';

class MatchHandler extends Handler {
  handle(goodsList: GoodsItem[]): GoodsItem[] {
    const condition = this.condition as GetGoodsListConditionMatch;
    return goodsList?.filter((item) => {
      for (const value of condition.value) {
        if (item[condition.key] === value) {
          return true;
        }
      }
    });
  }
}

export default MatchHandler;
